import Vue from 'vue'
import App from './App'
import router from './router'
import api from './axios/api'
import './axios'
import './axios/fetch'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'
import '@vant/touch-emulator'
import VueHtml5Editor from 'vue-html5-editor'
import 'font-awesome/css/font-awesome.min.css'
import config from '@/config'
import Vant from 'vant'
import 'vant/lib/index.css'
import vanNavBar from './components/vanNavBar/vanNavBar.js'
import { Lazyload } from 'vant'
import VueAMap from 'vue-amap' 

import vueSwiper from 'vue-awesome-swiper' 
import 'swiper/dist/css/swiper.css' 
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAMap)
Vue.use(vueSwiper) 
Vue.use(VueAwesomeSwiper)
VueAMap.initAMapApiLoader({
key: '72287657da7178b36762321a6c4964cf', // 如果没有这个key请去高德地图开放平台申请
plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.AMapManager', 'AMap.Marker'],
v: '1.4.4'
})
Vue.use(vanNavBar)
Vue.use(Vant)
Vue.use(Lazyload)
router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = to.meta.title
}
next()
})
import VConsole from 'vconsole'

if (process.env.NODE_ENV === 'deve_opment') {
var vConsole = new VConsole()
}
import store from './store'
Vue.config.productionTip = false

import filter from './filter/index'

for (var filteritem in filter) {
Vue.filter(filteritem, filter[filteritem])
}

import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Selector from 'vux/src/components/selector/index.vue'

Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)
Vue.use(Selector)
Vue.use(ElementUI)

const opt = {

name: 'vue-html5-editor',

showModuleName: true,

icons: {
text: 'fa fa-pencil',
color: 'fa fa-paint-brush',
font: 'fa fa-font',
align: 'fa fa-align-justify',
list: 'fa fa-list',
link: 'fa fa-chain',
unlink: 'fa fa-chain-broken',
tabulation: 'fa fa-table',
image: 'fa fa-file-image-o',
hr: 'fa fa-minus',
eraser: 'fa fa-eraser',
undo: 'fa-undo fa',
'full-screen': 'fa fa-arrows-alt',
info: 'fa fa-info'
},

image: {

sizeLimit: 512 * 1024 * 10,


upload: {

url: `${Vue.prototype.$config ? Vue.prototype.$config.host : 'https://test.xiujianshen.com/media/upload'}${api.common.upload}`,
fieldName: 'multipartFile',
headers: {},
params: {}
},


compress: {
width: 300,
height: null,
quality: 80
},

uploadHandler(responseText) {

var json = JSON.parse(responseText)
if (json.code == 0) {
return json.data
} else {
alert(json.message)
}
}
},

language: 'zh-cn',

i18n: {
'zh-cn': {
'align': '对齐方式',

'list': '列表',
'link': '链接',
'unlink': '去除链接',
'table': '表格',
'font': '文字',
'full screen': '全屏',
'text': '排版',
'eraser': '格式清除',
'info': '关于',
'color': '颜色',
'please enter a url': '请输入地址',
'create link': '创建链接',
'bold': '加粗',
'italic': '倾斜',
'underline': '下划线',
'strike through': '删除线',
'subscript': '上标',
'superscript': '下标',
'heading': '标题',
'font name': '字体',
'font size': '文字大小',
'left justify': '左对齐',
'center justify': '居中',
'right justify': '右对齐',
'ordered list': '有序列表',
'unordered list': '无序列表',
'fore color': '前景色',
'background color': '背景色',
'row count': '行数',
'column count': '列数',
'save': '确定',

'progress': '进度',
'unknown': '未知',
'please wait': '请稍等',
'error': '错误',
'abort': '中断',
'reset': '重置'
}
},

hiddenModules: [],

visibleModules: [
'text',
'color',
'font'











],


modules: {

}
}

Vue.use(VueHtml5Editor, opt)




if (process.env.NODE_ENV === 'development') {
console.log('process.env.NODE_ENV', process.env.NODE_ENV)

axios.get('./static/configLocal.json').then((result) => {
if (result) {

getUrlConfig(result)
} else {
alert('获取地址失败,将使用正式环境调试')
}
})
} else {
axios.get('./static/configOrg.json').then((result) => {
console.log('当前是云平台')
if (result) {

getUrlConfig(result)
} else {
alert('获取地址失败,将运营管理人员')
}
})
}

function getUrlConfig(result) {
localStorage.setItem('urlConfig', JSON.stringify(result.data))
if (localStorage.getItem('urlConfig')) {
const urlConfig = JSON.parse(localStorage.getItem('urlConfig'))
const config = {}
config.host = urlConfig.ApiUrl,
config.file = urlConfig.fileUploadUrl,
config.commonFile = urlConfig.burstFileUploadUrl,
config.socketUrl = urlConfig.socketUrl,
config.socketUrls = urlConfig.socketUrl,
config.fileUrl = urlConfig.filePreviewUrl,

config.appCode = 'WEBSITE_APP',
config.imgHost = '' 

Vue.prototype.$config = config
Vue.prototype.$common.setLocalStorage('tenantId', urlConfig.tenantId || '')

new Vue({
el: '#app',
router,
store,
data: {
eventHub: new Vue()
},
...App
})
}
}




// WEBPACK FOOTER //
// ./src/main.js